import React, { useState, useEffect } from "react";


import axios from "axios";


const { getNewYorkDateTime } = require("../utils/dateUtils");
function validateDOB(dobValue) {
 if (!dobValue) {
  return; // ✅ Skip DOB validation entirely
}


  // dobValue from <input type="date" /> is always YYYY-MM-DD
  const [year, month, day] = dobValue.split("-");
  const dob = new Date(year, month - 1, day);

  // Check if valid date
  if (isNaN(dob.getTime())) {
    return { valid: false, message: "⚠️ Invalid Date of Birth format!" };
  }

  // Age calculation
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--; // not had birthday yet this year
  }

  if (age < 18) {
    return { valid: false, message: "⚠️ You must be at least 18 years old!" };
  }

  // Format MM-DD-YYYY for display/validation
  const formattedDOB = `${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}-${year}`;

  return { valid: true, formattedDOB };
}





function AgentForm({ currentUser }) {
const initialFormState = {
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  email: "",
  phone: "",
  alternatePhone: "",
  address: "",
  apt: "",
  city: "",
  state: "",
  zip: "",
  dob: "",
  houseType: "",
  bankName: "",
  routingNumber: "",
  bankAddress: "",
  accountType: "",
  leadSource: "",
  cardNumber: "",
  expiry: "",
  cvv: "",
  product: "",
  transferredVerifier: null,

  // ✅ New Verification Fields
  verifCode: "",
  trackId: "",
centerName: currentUser?.center || "",
 agentName: currentUser 
  ? `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim()
  : "",

verifName: currentUser 
  ? `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim()
  : "",
  campaign: "",
  cardType: "",
  disposition: "",
  comments: "",
  submittedDate:""
};

const [products, setProducts] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]); // Products after validation


useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/products");

      // Filter only active products
      const activeProducts = res.data.filter(p => p.isActive === "Active");

      setProducts(activeProducts);
    } catch (err) {
      console.error("⚠️ Error fetching products:", err);
    }
  };
  fetchProducts();
}, []);


  const [centers, setCenters] = useState([]);

  useEffect(() => {
    // ✅ fetch dropdown values
    axios.get("https://crm-server-htk6.vercel.app/api/centers")
      .then((res) => setCenters(res.data))
      .catch((err) => console.error(err));
  }, []);








  //Disposition data fetch in dropdown 

   const [dispositions, setDispositions] = useState([]);

  useEffect(() => {
    // Fetch all dispositions from backend
    const fetchDispositions = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/dispositions");
        // filter only active ones
        const active = res.data.filter((d) => d.isActive === "Active");
        setDispositions(active);
      } catch (err) {
        console.error("⚠️ Error fetching dispositions:", err);
      }
    };

    fetchDispositions();
  }, []);

  const [campaigns, setCampaigns] = useState([]);

useEffect(() => {
  const fetchCampaigns = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaigns");

      console.log("Raw campaigns response:", res.data);

      // check if it's array or inside data property
      const campaignsData = Array.isArray(res.data) ? res.data : res.data.data;

      console.log("Parsed campaignsData:", campaignsData);

      // filter by isActive (boolean)
      const activeCampaigns = campaignsData.filter((c) => c.isActive);

      console.log("Active campaigns:", activeCampaigns);

      setCampaigns(activeCampaigns);
    } catch (err) {
      console.error("⚠️ Error fetching campaigns:", err);
    }
  };

  fetchCampaigns();
}, []);



  const [formData, setFormData] = useState(initialFormState);
  const [showDialog, setShowDialog] = useState(false);
  const [verifiers, setVerifiers] = useState([]);
  const [selectedVerifier, setSelectedVerifier] = useState(null);
    const [leadSources, setLeadSources] = useState([]); // ✅ new state

  const states = ["AK","AL","AR","AZ","CA","CO","CT","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY","GU",
"MP",
"PR",
"VI",
"DC"];
  const houseTypes = ["Own","Rented"];
  const accountTypes = ["Checking","Savings"];


   // ✅ Fetch Lead Sources from backend on mount
  useEffect(() => {
    const fetchLeadSources = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/leadSources");
        setLeadSources(res.data);
      } catch (err) {
        console.error("⚠️ Error fetching lead sources:", err);
      }
    };
    fetchLeadSources();
  }, []);



  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };



// const handleChange = (e) => {

  
//   const { name, value, type } = e.target;

//   // Skip uppercasing for date, numbers, and dropdowns
//   if (type === "date" || type === "number" || e.target.tagName === "SELECT") {
//     setFormData({ ...formData, [name]: value });
//   } else {
//     setFormData({ ...formData, [name]: value.toUpperCase() });
//   }

//   // ✅ If user deselects card type, clear card number
//   if (name === "cardType" && value === "") {
//     setFormData((prev) => ({ ...prev, cardNumber: "" }));
//   }

//   // ✅ If State or Card Type changes, reset Open Product and product list
//   if (name === "state" || name === "cardType" || name === "campaign"  || name === "leadSource") {
//     setFormData((prev) => ({ ...prev, product: "" }));
//     setFilteredProducts([]); // Clear validated product list
//     setSelectedProducts([]); // Clear checked products
//   }
// };

const handleChange = (e) => {
  const { name, value, type } = e.target;

  let newValue = value;

  // ✅ Prevent special characters for specific fields
  const fieldsToSanitize = ["address", "apt", "city", "state", "firstName", "lastName"];
  if (fieldsToSanitize.includes(name)) {
    // Allow only letters, numbers, spaces, and basic punctuation (.,-)
    newValue = newValue.replace(/[^a-zA-Z0-9\s.-]/g, "");
  }

  // ✅ Email field: allow only letters, numbers, ., _, -, @
  if (name === "email") {
    newValue = newValue.replace(/[^a-zA-Z0-9@._-]/g, "").toLowerCase();
  }

  // Skip uppercasing for date, numbers, and dropdowns
  if (type === "date" || type === "number" || e.target.tagName === "SELECT") {
    setFormData({ ...formData, [name]: newValue });
  } else {
    setFormData({ ...formData, [name]: newValue.toUpperCase() });
  }

  // ✅ If user deselects card type, clear card number
  if (name === "cardType" && value === "") {
    setFormData((prev) => ({ ...prev, cardNumber: "" }));
  }

  // ✅ If State or Card Type changes, reset Open Product and product list
  if (name === "state" || name === "cardType" || name === "campaign" || name === "leadSource") {
    setFormData((prev) => ({ ...prev, product: "" }));
    setFilteredProducts([]); // Clear validated product list
    setSelectedProducts([]); // Clear checked products
  }
};







  const resetForm = () => {
    setFormData(initialFormState);
    setSelectedVerifier(null);
    setFilteredProducts([]); // Clear validated product list
    setSelectedProducts([]); // Clear checked products
  };

  
// Full Validation
function validateForm(formData) {
  const mandatoryFields = [
    "firstName", "lastName", "gender", "phone",
    "address", "city", "state", "zip", "campaign" , "leadSource" 
    
  ];


  // 👉 New rule for disposition = "Sale"
  if (formData.disposition === "Sale") {
    if (!formData.comments?.trim()) {
      return { valid: false, message: "⚠️ Comments are required for a Sale disposition." };
    }
    if (!formData.trackId?.trim()) {
      return { valid: false, message: "⚠️ Track ID is required for a Sale disposition." };
    }
    if (!formData.verifCode?.trim()) {
      return { valid: false, message: "⚠️ Verifier Code is required for a Sale disposition." };
    }
  }

  



  // Mandatory fields
  for (let field of mandatoryFields) {
    if (!formData[field] || formData[field].toString().trim() === "") {
      return { valid: false, message: `⚠️ ${field} is required!` };
    }
  }

  
// ✅ Validate product selection (at least one checkbox must be selected)
// if (!selectedProducts || selectedProducts.length === 0) {
//   return { valid: false, message: "⚠️ Please select at least one product!" };
// }

if (formData.disposition === "Sale") {
  if (!selectedProducts || selectedProducts.length === 0) {
    return { valid: false, message: "⚠️ Please select at least one product for Sale!" };
  }
}


  // Phone
  const phoneRegex = /^[2-9]\d{9}$/;
  if (!phoneRegex.test(formData.phone)) {
    return { valid: false, message: "⚠️ Phone must be 10 digits and cannot start with 0 or 1!" };
  }

  // Zip
  const zipRegex = /^\d{5}$/;
  if (!zipRegex.test(formData.zip)) {
    return { valid: false, message: "⚠️ Zip Code must be exactly 5 digits!" };
  }

  // DOB
  // ✅ Only validate if DOB is not empty
if (formData.dob) {
  const dobValidation = validateDOB(formData.dob);
  if (!dobValidation.valid) return dobValidation;
}


  // Alternate Phone
  if (formData.alternatePhone && !/^[2-9]\d{9}$/.test(formData.alternatePhone)) {
    return { valid: false, message: "⚠️ Alternate Phone must be 10 digits and cannot start with 0 or 1!" };
  }

  // Routing Number
  if (formData.routingNumber && !/^\d{9}$/.test(formData.routingNumber)) {
    return { valid: false, message: "⚠️ Routing Number must be 9 digits!" };
  }

  // ✅ Card Number Validation
if (formData.cardType) {
  const cardNum = formData.cardNumber;
  if (!cardNum) {
    return { valid: false, message: "⚠️ Please enter Card Number!" };
  }

  // ✅ Remove "-" for validation
  const cleanCardNum = cardNum.replace(/-/g, "");

  const rules = {
    Visa: {
      regex: /^4\d{15}$/, 
      hint: "Visa cards must start with 4 and be 16 digits long."
    },
    "Master Card": {
      regex: /^5\d{15}$/, 
      hint: "MasterCard must start with 5 and be 16 digits long."
    },
    Discover: {
      regex: /^6\d{15}$/, 
      hint: "Discover cards must start with 6 and be 16 digits long."
    },
    "American Express": {
      regex: /^3\d{14}$/, 
      hint: "American Express must start with 3 and be 15 digits long."
    }
  };

  const rule = rules[formData.cardType];

  // ✅ check card type support
  if (!rule) {
    return { valid: false, message: `⚠️ Unsupported Card Type: ${formData.cardType}` };
  }

  // ✅ apply validation on sanitized number
  if (!rule.regex.test(cleanCardNum)) {
    return { valid: false, message: `⚠️ ${rule.hint}` };
  }
}



  // CVV
  if (formData.cvv && !/^\d{3}$/.test(formData.cvv)) {
    return { valid: false, message: "⚠️ CVV must be 3 digits!" };
  }

  // Expiry
  if (formData.expiry && !/^(0[1-9]|1[0-2])\/\d{2}$/.test(formData.expiry)) {
    return { valid: false, message: "⚠️ Expiry must be in MM/YY format!" };
  }

  return { valid: true };
}

const handleNumericInput = (e) => {
  const re = /^[0-9\b]+$/; // only digits
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};

// const handleSave = async () => {
//   // 1️⃣ Run Validation
//   const validation = validateForm(formData);
//   if (!validation.valid) {
//     alert(validation.message);
//     return;
//   }

//   // 2️⃣ Check Verifier selection
//   if (!selectedVerifier) {
//     alert("⚠️ Please select a verifier before saving!");
//     return;
//   }

//   // 3️⃣ Prepare finalData
//   let finalData = { ...formData };

//   if (currentUser.role !== "Verifier") {
//     finalData = {
//       ...formData,
//       verifCode: "",
//       trackId: "",
//       cardType: "",
//       disposition: "",
//       comments: "",
//       verifName: "",
//     };
//   }

//   finalData.submittedDate = new Date().toISOString();

//   try {
//     // 🔹 Calculate the date 6 months ago
//     const sixMonthsAgo = new Date();
//     sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

//     // 🔹 Fetch all agents to check duplicates
//     const agentsRes = await fetch("https://crm-server-htk6.vercel.app/api/agents");
//     const allAgents = await agentsRes.json();

//     // ✅ Check duplicates separately
//     let phoneDuplicate = false;
//     let cardDuplicate = false;

//     allAgents.forEach(agent => {
//       const agentDate = new Date(agent.submittedDate);
//       if (agentDate >= sixMonthsAgo) {
//         if (agent.phone && agent.phone === finalData.phone) {
//           phoneDuplicate = true;
//         }
//         if (agent.cardNumber && agent.cardNumber === finalData.cardNumber) {
//           cardDuplicate = true;
//         }
//       }
//     });

//     // 🔹 Show specific messages
//     if (phoneDuplicate || cardDuplicate) {
//       if (phoneDuplicate && cardDuplicate) {
//         alert("❌ Both Phone number and Card number have been used within the past 6 months.");
//       } else if (phoneDuplicate) {
//         alert("❌ Phone number has been used within the past 6 months.");
//       } else if (cardDuplicate) {
//         alert("❌ Card number has been used within the past 6 months.");
//       }
//       return; // ❌ Stop saving
//     }

//     // 4️⃣ Save Agent
//     const res = await fetch("https://crm-server-htk6.vercel.app/api/agents", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(finalData),
//     });

//     const result = await res.json();

//     if (result.success) {
//       alert("✅ Agent saved successfully");

//       // 5️⃣ Save Logs
//       const logData = {
//         ...finalData,
//         logDate: new Date().toISOString(),
//         user: currentUser?.firstName || "",
//         userCenter: currentUser?.center || "",
//         userEmpCode: currentUser?.empCode || "",
//         userRole: currentUser?.role || "",
//         action: "Save",
//       };

//       await fetch("https://crm-server-htk6.vercel.app/api/logs", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(logData),
//       });

//       resetForm();
//     } else {
//       alert("❌ Failed to save agent");
//     }
//   } catch (err) {
//     console.error("⚠️ Error saving agent:", err);
//     alert("⚠️ Error saving data");
//   }
// };



// ✅ Keep both state and setter
const [pendingSave, setPendingSave] = useState(null);
const [isProcessing, setIsProcessing] = useState(false);

const handleTransfer = async () => {
  if (isProcessing) return;
  setIsProcessing(true);

  try {
    // Form validation
    const validation = validateForm(formData);
    if (!validation.valid) {
      alert(validation.message);
      setIsProcessing(false);
      return;
    }

    // ✅ Ensure phone check is valid
    if (phoneCheckStatus !== "valid") {
      alert("❌ Please check your phone number before submitting.");
      setIsProcessing(false);
      return;
    }

    // ✅ Card number check only if cardNumber is not empty
    if (formData.cardNumber?.trim() && cardCheckStatus !== "valid") {
      alert("❌ Please check your card number before submitting.");
      setIsProcessing(false);
      return;
    }

    // ✅ Account number check only if accountNumber is not empty
    if (formData.accountNumber?.trim() && accountCheckStatus !== "valid") {
      alert("❌ Please check your account number before submitting.");
      setIsProcessing(false);
      return;
    }

    let finalData = { ...formData };

    if (currentUser.role !== "Verifier") {
      finalData = {
        ...formData,
        verifCode: "",
        trackId: "",
        cardType: "",
        disposition: "",
        comments: "",
        verifName: "",
      };
    }

    

    //finalData.submittedDate = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
//     const now = new Date();
// finalData.submittedDate = `${String(now.getMonth() + 1).padStart(2,"0")}/${String(now.getDate()).padStart(2,"0")}/${now.getFullYear()}`;

finalData.submittedDate = getNewYorkDateTime();



    // ✅ Fetch verifiers
    const res = await axios.get("https://crm-server-htk6.vercel.app/api/users");
    let filtered = [];
    if (currentUser.role === "Verifier") {
      filtered = [
        {
          _id: currentUser._id,
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          empCode: currentUser.empCode,
          role: currentUser.role,
          center: currentUser.center,
        },
      ];
    } else if (currentUser.role === "SuperAdmin") {
      filtered = res.data.filter((u) => u.role === "Verifier");
    } else {
      filtered = res.data.filter((u) => u.role === "Verifier" && u.center === currentUser.center);
    }

    setPendingSave(finalData);
    setVerifiers(filtered);
    setShowDialog(true);

  } catch (err) {
    console.error("⚠️ Error in transfer:", err);
    alert("⚠️ Error in transfer");
  } finally {
    setIsProcessing(false);
  }
};
const [saving, setSaving] = useState(false);


// const confirmSave = async () => { 
//   if (!selectedVerifier) {
//     alert("⚠️ Please select a verifier first!");
//     return;
//   }

//   // ✅ Prepare agent data
//   const updatedData = {
//     ...pendingSave,
//     transferredVerifier: {
//       firstName: selectedVerifier.firstName,
//       lastName: selectedVerifier.lastName,
//       empCode: selectedVerifier.empCode,
//     },
//     verifName: `${selectedVerifier.firstName || ""} ${selectedVerifier.lastName || ""}`.trim(),
//   };

//   // ✅ Add verifiedDate if disposition is not empty
//   if (formData.disposition && formData.disposition.trim() !== "") {
  
// updatedData.verifiedDate = getNewYorkDateTime();  
//   // updatedData.verifiedDate = `${String(now.getMonth() + 1).padStart(2, "0")}/${String(
//   //   now.getDate()
//   // ).padStart(2, "0")}/${now.getFullYear()}`;
// }

//   setFormData(updatedData);

//   try {
//     // 1️⃣ Save Agent
//     const res = await fetch("https://crm-server-htk6.vercel.app/api/agents", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(updatedData),
//     });

//     const result = await res.json();

//     if (result.success) {
//       alert("✅ Agent saved successfully");

//       // 2️⃣ Save Logs (only if agent save is successful)
//       try {
//         const logData = {
//           ...updatedData,
//         //  logDate: new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" })).toISOString(),

       
// logDate: getNewYorkDateTime(),



//           user: currentUser?.firstName || "",
//           userCenter: currentUser?.center || "",
//           userEmpCode: currentUser?.empCode || "",
//           userRole: currentUser?.role || "",
//           action: "Save", // ✅ Identify action
//         };

//         await fetch("https://crm-server-htk6.vercel.app/api/logs", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(logData),
//         });

//         console.log("📜 Log saved successfully");
//       } catch (logErr) {
//         console.error("⚠️ Error saving log:", logErr);
//       }

//       setShowDialog(false);
//       resetForm();
//     } else {
//       alert("❌ Failed to save agent");
//     }
//   } catch (err) {
//     console.error("⚠️ Error saving agent:", err);
//     alert("⚠️ Error saving data");
//   }
// };



// ------^&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&     VALIDATE PRODUCT AFTER RULES APPLIED   %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%


const confirmSave = async () => {
  if (!selectedVerifier) {
    alert("⚠️ Please select a verifier first!");
    return;
  }

  if (saving) return; // 🔒 Prevent double clicking

  setSaving(true);

  try {
    // 1️⃣ Fetch next available CustomerID
    const idRes = await fetch("https://crm-server-htk6.vercel.app/api/max-customer-id");
    const idData = await idRes.json();
    const CustomerID = idData.nextCustomerID;

    const updatedData = {
      ...pendingSave,
      CustomerID,
      transferredVerifier: {
        firstName: selectedVerifier.firstName,
        lastName: selectedVerifier.lastName,
        empCode: selectedVerifier.empCode,
      },
      verifName: `${selectedVerifier.firstName || ""} ${selectedVerifier.lastName || ""}`.trim(),
    };

    if (formData.disposition && formData.disposition.trim() !== "") {
      updatedData.verifiedDate = getNewYorkDateTime();
    }

    setFormData(updatedData);

    // 4️⃣ Save Agent
    const res = await fetch("https://crm-server-htk6.vercel.app/api/agents", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData),
    });

    const result = await res.json();

    if (result.success) {
      alert("✅ Agent saved successfully");

      const logData = {
        ...updatedData,
        logDate: getNewYorkDateTime(),
        user: currentUser?.firstName || "",
        userCenter: currentUser?.center || "",
        userEmpCode: currentUser?.empCode || "",
        userRole: currentUser?.role || "",
        action: "Save",
      };

      await fetch("https://crm-server-htk6.vercel.app/api/logs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(logData),
      });

      setShowDialog(false);
      resetForm();
    } else {
      alert("❌ Failed to save agent");
    }
  } catch (err) {
    console.error("⚠️ Error saving agent:", err);
    alert("⚠️ Error saving data");
  } finally {
    setSaving(false); // 🔚 Always stop loading
  }
};





    const [loading, setLoading] = useState(false);
   
  useEffect(() => {
    const validateProducts = async () => {
      try {
        setLoading(true);

        let validatedProducts = [...products];
        let blockedProducts = new Set();
        const centerName = currentUser?.center || "";

        // --- Product Mapping Validation ---
        // if (centerName && formData.leadSource && formData.campaign) {
        //   try {
        //     const mapRes = await axios.get(
        //       "https://crm-server-htk6.vercel.app/api/productMappings",
        //       {
        //         params: {
        //           center: centerName,
        //           leadSource: formData.leadSource,
        //           campaign: formData.campaign,
        //         },
        //       }
        //     );
        //     const mapping = mapRes.data;
        //     if (mapping && Array.isArray(mapping.products)) {
        //       validatedProducts = validatedProducts.filter(
        //         (p) => !mapping.products.includes(p.productName)
        //       );
        //     }
        //   } catch (mapErr) {
        //     console.error("Mapping error:", mapErr);
        //   }
        // }



        if (centerName && formData.leadSource && formData.campaign) {
  try {
    const mapRes = await axios.get(
      "https://crm-server-htk6.vercel.app/api/productMappings",
      {
        params: {
          center: centerName,
          leadSource: formData.leadSource,
          campaign: formData.campaign,
        },
      }
    );

    const mapping = mapRes.data;
    if (mapping && Array.isArray(mapping.products)) {
      validatedProducts = validatedProducts.filter(
        (p) => mapping.products.includes(p.productName)
      );
    }
  } catch (mapErr) {
    console.error("Mapping error:", mapErr);
  }
}


        // --- Per-product rules ---
        for (let product of [...validatedProducts]) {
          try {
            const res = await axios.get(
              `https://crm-server-htk6.vercel.app/api/productRules/${product._id}`
            );
            const rules = res.data;

            if (product.isActive !== "Active") {
              validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
              continue;
            }

            if (rules.states?.includes(formData.state)) {
              validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
              continue;
            }

            if (rules.cardTypes?.includes(formData.cardType)) {
              validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
              continue;
            }

            // if (rules.productGroup?.length) {
            //   rules.productGroup.forEach((bp) => blockedProducts.add(bp));
            // }

            // BIN range
          if (formData.cardNumber && formData.cardNumber.length >= 6) {
  // 1️⃣ Remove hyphens or spaces
  const cleanCard = formData.cardNumber.replace(/[^0-9]/g, "");

  // 2️⃣ Extract first 6 digits
  const cardPrefix = cleanCard.substring(0, 6);

  try {
    const binRes = await axios.get(
      `https://crm-server-htk6.vercel.app/api/bins/${product.productName}`
    );

    const bins = binRes.data;

    // 3️⃣ Correct BIN comparison
    const isBlockedByBin = bins.some((bin) => {
      const start = Number(bin.StartRange);
      const end = Number(bin.EndRange);
      const prefix = Number(cardPrefix);
      return prefix >= start && prefix <= end;
    });

    if (isBlockedByBin) {
      validatedProducts = validatedProducts.filter(
        (p) => p._id !== product._id
      );

      // 👉 also store it in blockedProducts state
      setBlockedProducts((prev) => new Set([...prev, product.productName]));

      continue;
    }
  } catch (binErr) {
    console.error(`Bin error for ${product.productName}:`, binErr);
  }
}

          } catch (ruleErr) {
            console.error(`Rule error for ${product.productName}:`, ruleErr);
          }
        }

        // Remove blocked by productGroup
        validatedProducts = validatedProducts.filter(
          (p) => !blockedProducts.has(p.productName)
        );

        setFilteredProducts(validatedProducts);
      } catch (err) {
        console.error("Validation failed:", err);
      } finally {
        setLoading(false);
      }
    };

    // Run validation if at least one key input is set
    if (products.length) {
      validateProducts();
    }
  }, [
    products,
    formData.state,
    formData.cardType,
    formData.campaign,
    formData.leadSource,
    formData.cardNumber,
    currentUser
  ]);



  // const handleProductSelect = (productName) => {
  //   let updatedProducts = selectedProducts.includes(productName)
  //     ? selectedProducts.filter((p) => p !== productName)
  //     : [...selectedProducts, productName];

  //   setSelectedProducts(updatedProducts);
  //   setFormData((prev) => ({ ...prev, product: updatedProducts.join(", ") }));
  // };


const [blockedProducts, setBlockedProducts] = useState(new Set());

const handleProductSelect = async (productName) => {
  setLoading(true);
  let updatedSelected = [...selectedProducts];
  let updatedBlocked = new Set(blockedProducts);

  try {
    // Toggle select/deselect
    if (updatedSelected.includes(productName)) {
      // Deselect
      updatedSelected = updatedSelected.filter((p) => p !== productName);

      // Recalculate blocked products based on remaining selections
      let newBlocked = new Set();
      for (let pName of updatedSelected) {
        const prod = products.find((x) => x.productName === pName);
        if (prod) {
          const res = await axios.get(
            `https://crm-server-htk6.vercel.app/api/productRules/${prod._id}`
          );
          const rules = res.data;
          if (rules.productGroup?.length) {
            rules.productGroup.forEach((bp) => newBlocked.add(bp));
          }
        }
      }
      updatedBlocked = newBlocked;
    } else {
      // Select product
      updatedSelected.push(productName);

      // Fetch rule for selected product
      const selectedProd = products.find((x) => x.productName === productName);
      if (selectedProd) {
        const res = await axios.get(
          `https://crm-server-htk6.vercel.app/api/productRules/${selectedProd._id}`
        );
        const rules = res.data;

        // Add all group members to blocked set
        if (rules.productGroup?.length) {
          rules.productGroup.forEach((bp) => updatedBlocked.add(bp));
        }
      }
    }

    setSelectedProducts(updatedSelected);
    setBlockedProducts(updatedBlocked);
    setFormData((prev) => ({ ...prev, product: updatedSelected.join(", ") }));
  } catch (err) {
    console.error("Error in handleProductSelect:", err);
  } finally {
    setLoading(false);
  }
};

const [cardStatus, setCardStatus] = useState(""); 
// "valid" | "invalid" | ""

const luhnCheck = (cardNumber) => {
  const num = cardNumber.replace(/-/g, "");
  let sum = 0;
  let double = false;

  for (let i = num.length - 1; i >= 0; i--) {
    let digit = parseInt(num[i]);

    if (double) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
    double = !double;
  }

  return sum % 10 === 0;
};


const [cardCheckStatus, setCardCheckStatus] = useState(null); // null | "valid" | "invalid"
const [accountCheckStatus, setAccountCheckStatus] = useState(null); // null | "valid" | "invalid"
const [phoneCheckStatus, setPhoneCheckStatus] = useState(null); // null | "valid" | "invalid"





const [cardError, setCardError] = useState("");
const handleCardDuplicateCheck = async () => {
  const value = formData.cardNumber?.replace(/-/g, "");

  if (!value || value.length !== 16) {
    setCardError("❌ Enter complete 16-digit card number.");
    setCardCheckStatus("invalid");
    return;
  }

  if (!luhnCheck(value)) {
    setCardError("❌ Invalid card number (Luhn failed).");
    setCardCheckStatus("invalid");
    return;
  }

  setCardError("Checking...");

  try {
    const res = await fetch(
      `https://crm-server-htk6.vercel.app/api/check-card?cardNumber=${value}`
    );
    const data = await res.json();

    if (data.exists) {
      setCardError("❌ This card number already exists in last 6 months.");
      setCardCheckStatus("invalid");
    } else {
      setCardError("✔ Card number is available.");
      setCardCheckStatus("valid");
    }

  } catch (error) {
    console.error(error);
    setCardError("⚠️ Error checking card number. Try again.");
    setCardCheckStatus("invalid");
  }
};

const [phoneError, setPhoneError] = useState("");
const handlePhoneCheck = async () => {
  const value = formData.phone?.trim();

  if (!value || value.length !== 10) {
    setPhoneError("❌ Enter a valid 10-digit phone number.");
    setPhoneCheckStatus("invalid");
    return;
  }

  setPhoneError("Checking...");

  try {
    const res = await fetch(
      `https://crm-server-htk6.vercel.app/api/check-phone?phone=${value}`
    );
    const data = await res.json();

    if (data.exists) {
      setPhoneError("❌ This phone number already exists within last 6 months.");
      setPhoneCheckStatus("invalid");
    } else {
      setPhoneError("✔ Phone number is available.");
      setPhoneCheckStatus("valid");
    }

  } catch (error) {
    console.error(error);
    setPhoneError("⚠️ Error checking phone. Try again.");
    setPhoneCheckStatus("invalid");
  }
};

const [accountError, setAccountError] = useState("");


const handleAccountDuplicateCheck = async () => {
  const value = formData.accountNumber?.trim();

  if (!value) {
    setAccountError("❌ Enter account number first.");
    setAccountCheckStatus("invalid");
    return;
  }

  if (value.length < 6) {
    setAccountError("❌ Account number must be at least 6 digits.");
    setAccountCheckStatus("invalid");
    return;
  }

  setAccountError("Checking...");

  try {
    const res = await fetch(
      `https://crm-server-htk6.vercel.app/api/check-account?accountNumber=${value}`
    );
    const data = await res.json();

    if (data.exists) {
      setAccountError("❌ This account number is already used in the last 6 months.");
      setAccountCheckStatus("invalid");
    } else {
      setAccountError("✔ Account number is available.");
      setAccountCheckStatus("valid");
    }

  } catch (error) {
    console.error(error);
    setAccountError("⚠️ Error checking account number. Try again.");
    setAccountCheckStatus("invalid");
  }
};





  return (

    
    <div className="form-container">
      <h2>Agent Form</h2>
      <form className="crm-form" >
        <div className="form-group">
          <label>First Name *</label>
          <input name="firstName" value={formData.firstName} onChange={handleChange}  />
        </div>
        <div className="form-group">
          <label>Middle Name </label>
          <input name="middleName" value={formData.middleName} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Last Name *</label>
          <input name="lastName" value={formData.lastName} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Gender *</label>
          <select name="gender" value={formData.gender} onChange={handleChange}>
            <option value="">Select</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
        </div>
        <div className="form-group">
          <label>Email </label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} />
        </div>
      <div className="form-group">
  <label>Phone *</label>

  <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
    <input
      name="phone"
      maxLength={10}
      value={formData.phone}
      onChange={handleChange}
      onKeyPress={handleNumericInput}
      style={{ flex: 1 }}
    />

    {/* CHECK BUTTON */}
    <button
      type="button"
      onClick={handlePhoneCheck}
      style={{
        padding: "5px 10px",
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer"
      }}
    >
      Check
    </button>
  </div>

  {/* ERROR OR SUCCESS MESSAGE */}
  {phoneError && (
    <div
      style={{
        color: phoneError.startsWith("✔") ? "green" : "red",
        fontSize: "12px",
        marginTop: "4px"
      }}
    >
      {phoneError}
    </div>
  )}
</div>


        <div className="form-group">
          <label>Alternate Phone </label>
          <input name="alternatePhone" maxLength={10} value={formData.alternatePhone} onChange={handleChange}    onKeyPress={handleNumericInput}/>
        </div>
        <div className="form-group full-width">
          <label>Address *</label>
          <input name="address" value={formData.address} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Address 2</label>
          <input name="apt" value={formData.apt} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>City *</label>
          <input name="city" value={formData.city} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>State *</label>
          <select name="state" value={formData.state} onChange={handleChange}>
            <option value="">Select</option>
            {states.map((s) => (<option key={s} value={s}>{s}</option>))}
          </select>
        </div>
        <div className="form-group">
          <label>Zip Code *</label>
          <input
  name="zip"
  value={formData.zip}
  onChange={handleChange}
  onKeyPress={handleNumericInput}
  maxLength={5}
/>

        </div>
        <div className="form-group">
          <label>Date of Birth </label>
          <input type="date" name="dob" value={formData.dob} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>House Type </label>
          <select name="houseType" value={formData.houseType} onChange={handleChange}>
            <option value="">Select</option>
            {houseTypes.map((h) => (<option key={h} value={h}>{h}</option>))}
          </select>
        </div>
        <div className="form-group">
          <label>Bank Name </label>
          <input name="bankName" value={formData.bankName} onChange={handleChange} 
             onPaste={(e) => e.preventDefault()}   // 🚫 block paste
    onCopy={(e) => e.preventDefault()}    // 🚫 block copy
    onCut={(e) => e.preventDefault()}     // 🚫 block cut
    style={{ imeMode: "disabled" }}       // 🚫 prevent IME auto input (extra layer)
          />
          
        </div>
        <div className="form-group">
          <label>Routing Number </label>
          <input name="routingNumber" maxLength={9} value={formData.routingNumber} onChange={handleChange}   onKeyPress={handleNumericInput} 
             onPaste={(e) => e.preventDefault()}   // 🚫 block paste
    onCopy={(e) => e.preventDefault()}    // 🚫 block copy
    onCut={(e) => e.preventDefault()}     // 🚫 block cut
    style={{ imeMode: "disabled" }}       // 🚫 prevent IME auto input (extra layer)
          />
        </div>
      <div className="form-group">
  <label>Account Number</label>

  <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
    <input
      name="accountNumber"
      value={formData.accountNumber}
      onChange={(e) => {
        let val = e.target.value.replace(/\D/g, ""); // only digits
        setFormData((prev) => ({ ...prev, accountNumber: val }));
        setAccountError(""); // clear error on typing
      }}
      onPaste={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      style={{ imeMode: "disabled" }}
    />

    {/* Duplicate Check Button */}
    <button
      type="button"
      onClick={handleAccountDuplicateCheck}
      style={{
        padding: "5px 10px",
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer"
      }}
      disabled={!formData.accountNumber}
    >
      Check
    </button>
  </div>

  {/* Show Duplicate or Valid Messages */}
  {accountError && (
    <p
      className={accountError.includes("✔") ? "success-text" : "error-text"}
    >
      {accountError}
    </p>
  )}
</div>

        <div className="form-group full-width">
          <label>Bank Address </label>
          <input name="bankAddress" value={formData.bankAddress} onChange={handleChange} />
        </div>
        
        <div className="form-group">
          <label>Account Type </label>
          <select name="accountType" value={formData.accountType} onChange={handleChange}>
            <option value="">Select</option>
            {accountTypes.map((a) => (<option key={a} value={a}>{a}</option>))}
          </select>
        </div>
       {/* Lead Source Dropdown */}


 <div className="form-group">
 <label>Card Type</label>
    <select name="cardType" value={formData.cardType} onChange={handleChange}>
      <option value="">Select</option>
      <option>Visa</option>
      <option>Master Card</option>
      <option>American Express</option>
      <option>Discover</option>
    </select>
    </div>
        {/* <div className="form-group">
        <label>Card Number</label>
<input
  name="cardNumber"
  value={formData.cardNumber}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, ""); // ✅ keep only digits
    value = value.substring(0, 16); // ✅ limit to 16 digits (standard card length)
    // ✅ insert "-" every 4 digits
    value = value.match(/.{1,4}/g)?.join("-") || "";
    setFormData({ ...formData, cardNumber: value });
  }}
  disabled={!formData.cardType} // ✅ disables input until cardType is selected
  placeholder={!formData.cardType ? "Select Card Type first" : ""}
  onPaste={(e) => e.preventDefault()}   // 🚫 block paste
  onCopy={(e) => e.preventDefault()}    // 🚫 block copy
  onCut={(e) => e.preventDefault()}     // 🚫 block cut
  style={{ imeMode: "disabled" }}       // 🚫 prevent IME auto input (extra layer)
/>

        </div> */}

<div className="form-group">
  <label>Card Number</label>

  <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
    <input
      name="cardNumber"
      value={formData.cardNumber}
      disabled={!formData.cardType}
      placeholder={!formData.cardType ? "Select Card Type first" : ""}
      className={
        cardStatus === "invalid"
          ? "input-error"
          : cardStatus === "valid"
          ? "input-success"
          : ""
      }
      onChange={(e) => {
        let value = e.target.value.replace(/\D/g, "");
        value = value.substring(0, 16);
        value = value.match(/.{1,4}/g)?.join("-") || "";

        setFormData((prev) => ({ ...prev, cardNumber: value }));

        const pure = value.replace(/-/g, "");

        if (pure.length === 16) {
          if (luhnCheck(pure)) {
            setCardStatus("valid");
          } else {
            setCardStatus("invalid");
          }
        } else {
          setCardStatus(""); // typing stage
        }

        // clear duplicate message while typing
        setCardError("");
      }}
    />

    {/* Duplicate Check Button */}
    <button
      type="button"
      onClick={handleCardDuplicateCheck}
     style={{
        padding: "5px 10px",
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer"
      }}
      disabled={!formData.cardNumber || cardStatus !== "valid"}
    >
      Check
    </button>
  </div>

  {/* Show Luhn messages */}
  {cardStatus === "invalid" && (
    <p className="error-text">❌ Invalid Card Number</p>
  )}

  {cardStatus === "valid" && (
    <p className="success-text">✔ Card Number is Valid</p>
  )}

  {/* Show Duplicate Messages */}
  {cardError && (
    <p
      className={cardError.includes("✔") ? "success-text" : "error-text"}
    >
      {cardError}
    </p>
  )}
</div>



        <div className="form-group">
        <label>Expiry (MM/YY) </label>
<input
  name="expiry"
  placeholder="MM/YY"
  value={formData.expiry}
  maxLength={5} // ✅ ensures only MM/YY format
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, ""); // remove non-digits
    if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2, 4);
    }

    // ✅ Validation: prevent expired dates
    if (value.length === 5) {
      const [mm, yy] = value.split("/");
      const month = parseInt(mm, 10);
      const year = parseInt("20" + yy, 10); // convert YY → YYYY

      if (month < 1 || month > 12) {
        return; // invalid month → reject
      }

      const today = new Date();
      const expiryDate = new Date(year, month - 1, 1);
      const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

      if (expiryDate < currentMonth) {
        // ❌ Expired → ignore input
        return;
      }
    }

    setFormData((prev) => ({ ...prev, expiry: value }));
  }}
/>


        </div>
        <div className="form-group">
          <label>CVV </label>
          <input name="cvv"  maxLength={formData.cardType === "American Express" ? 4 : 3} onChange={handleChange}   onKeyPress={handleNumericInput} 
          
             onPaste={(e) => e.preventDefault()}   // 🚫 block paste
    onCopy={(e) => e.preventDefault()}    // 🚫 block copy
    onCut={(e) => e.preventDefault()}     // 🚫 block cut
    style={{ imeMode: "disabled" }}       // 🚫 prevent IME auto input (extra layer)
          />
        </div>
        <div className="form-group">
  <label>Lead Source *</label>
  <select
    name="leadSource"
    value={formData.leadSource}
    onChange={handleChange}
  >
    <option value="">-- Select Lead Source --</option>
    {leadSources.map((src) => (
      <option key={src._id} value={src.name}>
        {src.name}
      </option>
    ))}
  </select>
</div>
 <div className="form-group">
                <label>Campaign *</label>
                <select
                  name="campaign"
                  value={formData.campaign}
                  onChange={handleChange}
                >
                  <option value="">-- Select Campaign --</option>
                  {campaigns.map((c) => (
                    <option key={c._id} value={c.campaignName}>
                      {c.campaignName}
                    </option>
                  ))}
                </select>
              </div>
        <div className="form-group full-width">
        
          <label>Product Selected</label>
         
         <textarea
    name="product"
    value={formData.product} // now synced with selectedProducts
    readOnly
  />
        </div>
      
              <div className="form-group">
                <label>Center Name</label>
                 <select
                  name="centerName"
                    value={formData.centerName}
                  onChange={handleChange}
                >
                  
                  {centers.map((c) => (
                    <option key={c._id} value={c.centerName}>
                      {c.centerName}
                    </option>
                  ))}
                </select>
              </div>
            
            
{/* <div className="form-group full-width">
  <label>Select Products</label>

  <div
    className="product-list"
    style={{
      position: "relative",       // 👈 important so loader can absolutely position inside
      minHeight: "150px"          // optional, ensures space even while loading
    }}
  >
    {loading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.7)", // semi-transparent overlay (optional)
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
          zIndex: 10
        }}
      >
        ⏳ Validating products...
      </div>
    )}

    {filteredProducts.map((p) => (
      <label
        key={p._id}
        style={{ display: "block", marginBottom: "0.25rem" }}
      >
        <input
          type="checkbox"
          checked={selectedProducts.includes(p.productName)}
          onChange={() => handleProductSelect(p.productName)}
        />
        {" "}{p.productName}
      </label>
    ))}
  </div>
</div> */}





<div className="form-group full-width">
  <label>Select Products</label>

  <div
    className="product-list"
    style={{
      position: "relative",
      minHeight: "150px",
    }}
  >
    {loading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
          zIndex: 10,
        }}
      >
        ⏳ Validating products...
      </div>
    )}

    {/* 👇 Replace your old map() block with this one */}
    {filteredProducts.map((p) => {
      const isSelected = selectedProducts.includes(p.productName);
      const isBlocked = blockedProducts.has(p.productName);

      return (
        <label
          key={p._id}
          style={{
            display: "block",
            marginBottom: "0.25rem",
            opacity: isBlocked && !isSelected ? 0.5 : 1,
            cursor: isBlocked && !isSelected ? "not-allowed" : "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            disabled={isBlocked && !isSelected} // 🚫 block selection if product is in productGroup
            onChange={() => handleProductSelect(p.productName)}
          />
          {" "}{p.productName}
          {isBlocked && !isSelected && (
            <span style={{ color: "red", marginLeft: "5px" }}>(Blocked)</span>
          )}
        </label>
      );
    })}
  </div>
</div>




              <div className="form-group">
                <label>Agent Name</label>
                <input name="agentName" value={formData.agentName} readOnly />
              </div>
           


{/* ✅ Show Verifier Forms ONLY if user is Verifier */}
        {currentUser?.role === "Verifier" && (
          <>
          <div className = " form-group full-width" >
            <h3 className="section-heading">Verifier Form</h3></div>

            <div className="verify-form-row"></div>
              <div className="form-group">
                <label>Verification Code</label>
                <input
                  name="verifCode"
                  value={formData.verifCode}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Track ID</label>
                <input
                  name="trackId"
                  value={formData.trackId}
                  onChange={handleChange}
                />
              </div>
   
              <div className="form-group">
                <label>Verifier Name</label>
                <input name="verifName" value={formData.verifName} readOnly />
              </div>
     

            

         
              <div className="form-group">
                <label>Disposition</label>
                <select
                  name="disposition"
                  value={formData.disposition}
                  onChange={handleChange}
                >
                  <option value="">-- Select Disposition --</option>
                  {dispositions.map((d) => (
                    <option key={d._id} value={d.disposition}>
                      {d.disposition}
                    </option>
                  ))}
                </select>
              </div>
         

            <div className="verify-form-row">
              <div className="verify-form-group full-width">
               <label>Comments</label>
<textarea
  name="comments"
  value={formData.comments || ""}
  onChange={(e) => {
    if (e.target.value.length <= 300) {
      handleChange(e); // ✅ only update if ≤ 300 chars
    }
  }}
  maxLength={300} // ✅ ensures user can't type beyond 300
  placeholder="Enter your comments (max 300 characters)"
  rows={4}
  style={{ width: "200%", resize: "vertical" }}
></textarea>

<p style={{ fontSize: "12px", color: "#555" }}>
  {formData.comments?.length || 0}/300 characters
</p>

              </div>
            </div>
          </>
        )}










        {/* Buttons */}
        
        <div className="form-actions">
          <button type="button" className="btn transfer" onClick={handleTransfer}   disabled={isProcessing} >
           {isProcessing ? "Processing..." : "Transfer to Verifier"} 
          </button>
        </div>
      </form>

      {/* Transfer Dialog */}
    {showDialog && (
  <div className="dialog-overlay">
    <div className="dialog-box">
      <h3>Select Verifier</h3>

{verifiers.length === 0 ? (
  <p>No verifiers available in your center.</p>
) : (
  <ul
    style={{
      maxHeight: "250px",
      overflowY: "auto",
      paddingRight: "5px"
    }}
  >
    {verifiers.map((v) => (
      <li key={v._id} className="verifier-item">
        <label>
          <input
            type="checkbox"
            checked={selectedVerifier?._id === v._id}
            onChange={() => setSelectedVerifier(v)}
          />
          {v.firstName} {v.lastName} ({v.empCode})
        </label>
      </li>
    ))}
  </ul>
)}


      <div className="dialog-actions">
        <button
          className="btn save"
           disabled={saving}
          onClick={confirmSave} // ✅ validate & save
        >
          {saving ? "Saving..." : "Save"}
        </button>
    
        <button
          className="btn close-btn"
          onClick={() => setShowDialog(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}

export default AgentForm;
